// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__tP5jr","info":"styles_info__kmmVw","poiTitle":"styles_poiTitle__KY3FO"};
module.exports.__checksum = "c01867e1ab89"